/**
 * Permission Mapper
 * Maps between API DTOs and Domain Entities
 */

import {
  PermissionResponseDTO,
  RolePermissionsDTO,
  ModuleDTO,
  ActionDTO,
  ReviewPolicyDTO,
} from "../models/PermissionDTOs";
import {
  PermissionsMap,
  PermissionEntity,
  RolePermissionsEntity,
} from "../../domain/entities/PermissionEntity";

export class PermissionMapper {
  /**
   * Convert PermissionResponseDTO to PermissionsMap entity
   */
  static toPermissionEntity(dto: PermissionResponseDTO): PermissionsMap {
    return dto.data.permissions || {};
  }

  /**
   * Convert RolePermissionsDTO to RolePermissionsEntity
   */
  static toRolePermissionsEntity(
    dto: RolePermissionsDTO
  ): RolePermissionsEntity {
    return dto.data || {};
  }

  /**
   * Convert ModuleDTO to ModuleEntity
   */
  static toModuleEntity(dto: ModuleDTO) {
    return {
      module_code: dto.module_code,
      module_name: dto.module_name,
    };
  }

  /**
   * Convert ActionDTO to ActionEntity
   */
  static toActionEntity(dto: ActionDTO) {
    return {
      action_code: dto.action_code,
      action_name: dto.action_name,
    };
  }

  /**
   * Convert ReviewPolicyDTO to ReviewPolicyEntity
   */
  static toReviewPolicyEntity(dto: ReviewPolicyDTO) {
    return {
      id: dto.id,
      role: dto.role,
      moduleCode: dto.module_code,
      moduleName: dto.module_name,
      actionCode: dto.action_code,
      actionName: dto.action_name,
      requiresReview: dto.requires_review,
    };
  }
}
